import React from 'react';
import { Text } from 'react-native';
import { Important_note } from '../../../utils/DictionaryManagementUtils';
import SubHeadlineFullPagePanel from './SubHeadlineFullPagePanel';

//= ========================================================================

const ImportantNote = ({
  children,
}) => {
  const myStyles = {
    container: {
      marginBottom: 26,
    },
    note: {
      fontFamily: 'Rubik-Medium',
      fontSize: 16,
      color: '#4a5568',
    },
  };
  return (
    <Text style={myStyles.container}>
      <Text style={myStyles.note}>
        {Important_note}
      </Text>
      <SubHeadlineFullPagePanel marginTop={0}>{children}</SubHeadlineFullPagePanel>
    </Text>
  );
};

export default ImportantNote;
